import React from 'react';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import SeoFloatingMenu from '../floating_topbar/menus/FloatingMenu';
import { MENU_CONTENT_TYPES } from '../floating_topbar/menus/consts';
import { sortNavigation, shouldSortNavigate } from '../../../service/clientNavigation';

const SortBy = ({ title, data }) => (
    <I18nProvider>
        {({ i18n }) => (
            <div className="sort-by-wrapper">
                <span className="pre-title">{i18n.t('search_perseus.sorting.sort_by')}</span>
                <SeoFloatingMenu title={title}
                    id="sort-by"
                    data={data}
                    menuTitle={i18n.t('search_perseus.sorting.sort_by')}
                    titleClass="sort-filter"
                    showApply={false}
                    showClearAll={false}
                    contentType={MENU_CONTENT_TYPES.LABELS_LIST}
                    activeFilters={data}
                    navigationCondition={shouldSortNavigate}
                    applyNavigation={sortNavigation}
                    additionalProps={{ closeOnClick: true }}/>
            </div>
        )}
    </I18nProvider>
);

export default SortBy;
